// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"d2e8b759","218":"e7c4aeb8","277":"bc01d595","488":"3eabe148","525":"2b1d5d11","619":"ab78a0d7"}[chunkId] + ".chunk.js";
};